exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mp-copy-to-clipboard {\n  display: flex;\n  flex-direction: row;\n}\n.copy-input {\n  margin-right: 5px;\n}\n.copy-button {\n  align-self: flex-end;\n  display: flex;\n  position: relative;\n}\n.copied {\n  color: #219464;\n  padding: 5px;\n}\n", ""]);

// exports
